import { setCloseStepValidation } from './closeStepValidation';

export const chargeQuantitySet = (state, action) => {
    let currentCharges = state.getIn(['workOrderDetails', action.orderId, 'charges', 'details']);

    currentCharges = currentCharges.update(currentCharges.findIndex((item) => {
        return item.get('chargeID') === action.chargeId;
    }), (item) => {

        if (!item.get('startingQuantity') && item.get('startingQuantity') !== 0) {
            item = item.set('startingQuantity', item.get('quantity'));
        }

        const newQuantity = parseInt(action.quantity);
        const startingQuantity = parseInt(item.get('startingQuantity'));

        item = item
            .set('message', null)
            .set('error', null)
            .set('hasUnsavedChanges', false)
            .set('isValid', true);

        if (item.get('requiresComment') && newQuantity > 0 && !item.get('comment')) {
            item = item
                .set('error', 'A comment is required.')
                .set('isValid', false);
        }

        if (item.get('transactionId') > 0 && newQuantity !== startingQuantity) {
            item = item.set('action', 'update');
        }

        if (item.get('transactionId') > 0 && newQuantity === 0) {
            item = item.set('action', 'update');
        }

        if ((!item.get('transactionId') || item.get('transactionId') <= 0) && newQuantity > 0) {
            item = item.set('action', 'add');
        }

        if (newQuantity === startingQuantity) {
            item = item.set('action', null);
        }

        if (newQuantity !== startingQuantity) {
            item = item.set('hasUnsavedChanges', true);
        }
        return item.set('quantity', newQuantity);
    });

    state = state.setIn([
        'workOrderDetails',
        action.orderId,
        'charges',
        'chargeGroups',
        'serviceCallFee',
        'hidden'
    ], false);

    state = state.setIn([
        'workOrderDetails', action.orderId, 'charges', 'details'
    ], currentCharges);

    return setCloseStepValidation(state, action.orderId);

};

export const chargeAddFailed = (state, action) => {
    let currentCharges = state.getIn(['workOrderDetails', action.orderId, 'charges', 'details']);

    currentCharges = currentCharges.update(currentCharges.findIndex((item) => {
        return item.get('billingSystemChargeID') === action.payload.billingSystemChargeID;
    }), (item) => {

        return item
            .set('error', 'Save failed.')
            .set('loading', false);
    });

    state = state.setIn([
        'workOrderDetails', action.orderId, 'charges', 'details'
    ], currentCharges);

    return setCloseStepValidation(state, action.orderId);
};

export const chargeAddStarted = (state, action) => {
    let currentCharges = state.getIn(['workOrderDetails', action.orderId, 'charges', 'details']);

    currentCharges = currentCharges.update(currentCharges.findIndex((item) => {
        return item.get('billingSystemChargeID') === action.request.billingSystemChargeID;
    }), (item) => {

        return item
            .set('error', null)
            .set('loading', true)
            .set('message', null);
    });

    state = state.setIn([
        'workOrderDetails', action.orderId, 'charges', 'details'
    ], currentCharges);

    return setCloseStepValidation(state, action.orderId);
};

export const chargeAddFinished = (state, action) => {
    let currentCharges = state.getIn(['workOrderDetails', action.orderId, 'charges', 'details']);
    currentCharges = currentCharges.update(

        currentCharges.findIndex((item) => {
            return item.get('billingSystemChargeID') === action.payload.billingSystemChargeID;
        }), (item) => {

            return item
                .set('message', 'Save Complete.')
                .set('loading', false)
                .set('startingQuantity', action.payload.quantity)
                .set('transactionId', action.payload.transactionID)
                .set('action', null)
                .set('hasUnsavedChanges', false);
        }
    );

    state = state.setIn([
        'workOrderDetails', action.orderId, 'charges', 'details'
    ], currentCharges);

    return setCloseStepValidation(state, action.orderId);
};

export const chargeCommentSet = (state, action) => {
    let currentCharges = state.getIn(['workOrderDetails', action.orderId, 'charges', 'details']);

    currentCharges = currentCharges.update(currentCharges.findIndex((item) => {
        return item.get('chargeID') === action.chargeId;
    }), (item) => {

        if (!item.get('originalComment')) {
            item = item.set('originalComment', item.get('comment'));
        }

        if (item.get('requiresComment') && action.comment) {
            item = item
                .set('error', null)
                .set('isValid', true);
        }

        if (item.get('requiresComment') && !action.comment) {
            item = item
                .set('error', 'A comment is required.')
                .set('isValid', false);
        }

        if (item.get('originalComment') !== action.comment) {
            item = item.set('hasUnsavedChanges', true);
        }

        if (item.get('originalComment') !== action.comment && item.get('transactionId') !== 0) {
            item = item.set('action', 'update');
        }

        return item.set('comment', action.comment);
    });

    state = state.setIn([
        'workOrderDetails', action.orderId, 'charges', 'details'
    ], currentCharges);

    return setCloseStepValidation(state, action.orderId);

};

export const chargeUpdateCancelled = (state, action) => {
    let currentCharges = state.getIn(['workOrderDetails', action.orderId, 'charges', 'details']);

    currentCharges = currentCharges.update(currentCharges.findIndex((item) => {
        return item.get('billingSystemChargeID') === action.request.billingSystemChargeID;
    }), (item) => {

        return item
            .set('loading', false)
            .set('message', null);
    });

    state = state.setIn([
        'workOrderDetails', action.orderId, 'charges', 'details'
    ], currentCharges);

    return setCloseStepValidation(state, action.orderId);
};



// WEBPACK FOOTER //
// ./src/reducers/work-order/charges.js